import script from "./coupon.vue?vue&type=script&setup=true&lang=js"
export * from "./coupon.vue?vue&type=script&setup=true&lang=js"

import "./coupon.vue?vue&type=style&index=0&id=6ea3e042&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\Other\\EventMaster\\Dataleading3.0\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea3e042"]])

export default __exports__